import React from "react";

const SvgSwingHorSelected = props => (
  <svg width={40} height={40} {...props}>
    <g fill="none" fillRule="evenodd" opacity={0.4}>
      <path fill="#FDFDFE" d="M3 3v9a9 9 0 0 0 9-9H3z" />
      <path
        stroke="#FDFDFE"
        strokeLinecap="round"
        strokeOpacity={0.5}
        strokeWidth={2}
        d="M19.599 9.766l13.717 6.07m-17.119-.139l10.606 10.606M10.694 19.15l5.438 13.98M4 20v15"
      />
      <path
        stroke="#FDFDFE"
        strokeLinecap="round"
        strokeWidth={2}
        d="M20 4h15"
      />
    </g>
  </svg>
);

export default SvgSwingHorSelected;
